module.exports = __webpack_public_path__ + "static/media/msyh.f80465e9.ttf";